import { useQuery } from '@tanstack/vue-query';
import { computed } from 'vue';

import type { SearchableSelectOption } from '~/components/shared/SearchableSelect.vue';

import installationRiskHttp from '~/services/installation-risk-api/installation-risk-api.http';

import { createBrandsService } from '../services/brandsService';

export function useBrands(entity: string) {
  const brandsService = createBrandsService(entity, installationRiskHttp);

  return useQuery({
    queryFn: brandsService.list.bind(brandsService),
    queryKey: ['brands', entity],
    staleTime: 5 * 60 * 1000, // 5 minutos
  });
}

export function useBrandsOptions(entity: string) {
  const { data: brandsData, isLoading } = useBrands(entity);

  const options = computed<SearchableSelectOption[]>(() => {
    if (!brandsData.value?.data) return [];

    return brandsData.value.data.map((brandName) => ({
      label: brandName,
      value: brandName,
    }));
  });

  return {
    isLoading,
    options,
  };
}
